import { getWidthPercentage } from '@/app/utils/helpers';
import HELPER from '@/app/utils/HELPER';
import { AtomTargetHandler } from './AtomTargetHandler';
import type { AtomModel } from '@/app/editor/iframe/atom/Atom.model';
import { getCurrency } from '@/app/utils/helpers';
/**
 * P Image Badge Setting Handler
 */
export class ShBadgeDisplayType extends AtomTargetHandler {
  /**
   * read
   * @param options options
   * @param options.screenType screenType
   * @param options.$activePanel $activePanel
   */
  read(options: { screenType: any; $activePanel: JQuery; $atom: JQuery; atomModel: AtomModel }) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const targetSelector = this.setting.targetSelector as string;
    const $self = this.getAtomTarget('read', this);
    const style = this.getAtomModel().style;
    let value: any = '';

    value = HELPER.getValueFromCSS($self, style, this.setting.property, options.screenType, targetSelector);
    if ((this.setting.name == 'width' || this.setting.name == 'height') && value === '') {
      value = 'auto';
    }
    if (this.setting.options?.length) {
      for (let i = 0; i < this.setting.options.length; i++) {
        const option = this.setting.options[i];
        if (option.value == value) {
          value = option.key;
        }
      }
    }
    if (!value || value == undefined) {
      value = this.setting.default_value ? this.setting.default_value : '';
    }
    if (this.setting.require) {
      const $target = $self.find(targetSelector);
      value = $target.css(this.setting.property);
    }
    if (this.setting.fieldType == 'color') {
      if (!value || value == 'none') {
        value = this.setting.default_value;
      }
      value = HELPER.rgb2hex(value);
    }
    if (value != '' || !value) {
      // convert px to em
      if (this.setting.property == 'line-height' && this.setting.unit == 'em' && value.indexOf('px') !== -1) {
        const fontSize = $self.find(targetSelector).css('font-size');
        try {
          const val = parseInt(value) / parseInt(fontSize);
          value = val.toFixed(2) + 'em';
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('fail to convert px to em');
        }
      }
      if (this.setting.property == 'width' && this.setting.unit == '%' && value.indexOf('px') !== -1) {
        const $target = $self.find(targetSelector);
        value = getWidthPercentage($target) + '%';
      }
    }
    if (value === undefined || value === '') {
      value = '';
      options.$activePanel.find(`[name="${this.setting.name}"]`).attr('default_value', value).trigger('value-change');
    }
    options.$activePanel.find(`[name="${this.setting.name}"]`).attr('value', value).val(value).trigger('value-change');
    return { value: value };
  }

  /**
   * write
   * @param value value
   * @param options options
   * @param options.screenType screenType
   * @returns style
   */
  write(
    value: string,
    options: {
      screenType: any;
      $atom: JQuery;
      $activePanel: JQuery;
      atomModel: AtomModel;
    },
  ) {
    this.set$el(options.$atom);
    this.setAtomModel(options.atomModel);
    const targetSelector = this.setting.targetSelector as string;

    let style = this.getAtomModel().style;
    const refreshType = this.setting.refreshType ? this.setting.refreshType : 'css';
    if (!targetSelector) {
      alert(`Thiếu targetSelector: ${this.setting.name}`);
    } else {
      const currency = getCurrency(options.$atom);
      const displayType = options.$activePanel.find('#displayType').val();
      let $PImageModule = options.$atom.closest('[data-label="(P) Image"]');
      if ($PImageModule.length == 0) {
        $PImageModule = options.$atom.closest('[data-icon="gpicon-product-image"]');
      }
      const $sellOffUnit = $PImageModule.find('.gf_badge-text-wrap').find('.data-saleoffunit');
      if (displayType == 'number') {
        if (options.$activePanel.find('#textUnit').val() === '%') {
          options.$activePanel.find('#textUnit').val(currency).attr('value', currency).trigger('value-change');
          options.$atom.find('.module').attr('data-displayunit', currency);
          $sellOffUnit.html(currency);
        }
      } else if (displayType == 'percentage') {
        options.$activePanel.find('#textUnit').val(currency).attr('value', '%').trigger('value-change');
        options.$atom.find('.module').attr('data-displayunit', '%');
        $sellOffUnit.html('%');
      }
      const deOptions = [
        {
          key: 'margin-left',
          value: options.$activePanel.find('#priceMargin').val(),
        },
      ];
      style = HELPER.designOptions2Style(options.$atom, options.screenType, style, deOptions, $sellOffUnit);
    }
    return {
      refreshType: refreshType,
      style: style,
    };
  }
  /**
   * getAtomModel
   * @returns atomModel :jQuery
   */
  getAtomModel() {
    return this.atomModel;
  }
}
